const LISTAR_DADOS = (state, payload) => {
  state.items = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const ATUALIZAR_PAGINACAO = (state, payload) => {
  state.paginacao = payload
}

export {
  LISTAR_DADOS,
  CARREGANDO,
  ATUALIZAR_PAGINACAO
}
